<template>
  <div id="toDo">
		<el-card>
			<el-form :model="searchForm" ref="searchForm" label-width="160px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Name:" prop="flowName">
							<el-input clearable v-model="searchForm.flowName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Type:" prop="flowType">
							<el-select clearable v-model="searchForm.flowType" placeholder="Please select">
								<el-option
									v-for="item in flowType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Current Processor:" prop="currentProcessor">
							<el-select
								v-model="searchForm.currentProcessor"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('currentProcessorList', value)"
							>
								<el-option v-for="(item, index) in currentProcessorList.slice(0, 10)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Submitter:" prop="submitter">
							<el-select
								v-model="searchForm.submitter"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('submitterList', value)"
							>
								<el-option v-for="(item, index) in submitterList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="24" :md="12" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="flowName" label="E-flow Name" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="flowTypeDesc" label="E-flow Type" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="approvalStatusDesc" label="Approval Status" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="currentProcessor" label="Current Processor" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="submitter" label="Submitter" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="submissionTime" label="Submission Time" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lastProcessor" label="Last Processor" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lastProcessedTime" label="Last Processed Time" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" min-width="120">
					<template slot-scope="scope">
          	<el-button size="small" type="primary" @click="openDetail(scope.row)">Approval</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
		</el-card>
		<el-drawer
			title="Detail"
			size="80vw"
			:visible.sync="approveDrawer"
			:before-close="closeDetail"
			:destroy-on-close = true
		>
			<detail ref="detail" :approveInfo="approveInfo" :approvalHistory="approvalHistory" @close="closeDetail" />
		</el-drawer>
  </div>
</template>
<script>
	import detail from './detail.vue'
  export default {
    name: 'workbenchToDo',
		components: {
			detail
		},
    created () {
			this.getSelectInfo();
			this.handleSearch();
    },
    data () {
      return {
				flowType: [],
				searchForm: {},
				showMore: false,
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				approveDrawer: false,
				approveInfo: {},
				approvalHistory: [],
				currentProcessorList: [],
				submitterList: [],
      }
    },
    methods: {
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'flowType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key]; 
							});
						}
					}
				)
			},
			handleSearch()  {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}majorProjectFlow/getToDoListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				this.exportLoading = false;
			},
			filterMoreSearch() {
				this.showMore = !this.showMore;
			},
			openDetail(record) {
				this.approveDrawer = true
				this.approveInfo = record
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					eosToken : sessionStorage.getItem('eostoken'),
				}
				let url =`${this.$store.state.islhurl}majorProjectFlowRecord/getFlowRecordByFlowId?flowId=${record.id}`
				this._post(url,params).then(
					res => {
						if(res.code === 200) {
							this.approvalHistory = res.data
						} else {
							this.approvalHistory = []
						}
					}
				)
			},
			closeDetail(type) {
				this.approveDrawer = false
				this.approveInfo = {}
				// this.$refs.detail.approveForm = {}
				console.log('close')
				if(type === 'refresh') {
					this.handleSearch()
				}
			},
			projectDiscard() {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						console.log(this.editForm)
						let params = {
							islhToken : sessionStorage.getItem('islhtoken'),
						}
						this.tableLoading = true;
						let url =`${this.$store.state.islhurl}majorProjectFlow/discard`
						this._post(url,params).then(
							res => {
								this.tableLoading = false;
								if(res.code === 200) {
								this.tableData = res.data;
								this.totalCount = res.totalNums;
								} else {
									this.tableData = [];
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					} else {
						return false;
					}
				});
			}
		},
  }
</script>
<style lang="less" scoped>
#toDo {
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	.longlabel {
		/deep/.el-form-item__label {
			padding: 0 12px;
			line-height: 20px;
		}
	}
	/deep/.el-drawer__header {
		margin-bottom: 0;
		padding: 24px;
		font-size: 20px;
		color: #000;
		font-weight: 600;
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
			.el-form-item {
				margin-bottom: 20px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/myworkbench/toDo/index.vue